module.exports = __webpack_public_path__ + "static/media/new-power.1b86984e.svg";